import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import Span from './tag/Span';

import placeholderTimeline from '../images/placeholders/timeline.jpg';
import placeholderQuestionnaires from '../images/placeholders/questionnaires.jpg';
import placeholderRemoteClinic from '../images/placeholders/remoteclinic.jpg';
import placeholderCareConversations from '../images/placeholders/hoitokeskustelut.jpg';
import placeholderAppointments from '../images/placeholders/appointments.jpg';
import placeholderServices from '../images/placeholders/services.jpg';
import placeholderTimelineSmall from '../images/placeholders/timelineSmall.jpg';
import placeholderQuestionnairesSmall from '../images/placeholders/questionnairesSmall.jpg';
import placeholderRemoteClinicSmall from '../images/placeholders/remoteclinicSmall.jpg';
import placeholderCareConversationsSmall from '../images/placeholders/hoitokeskustelutSmall.jpg';
import placeholderAppointmentsSmall from '../images/placeholders/appointmentsSmall.jpg';
import placeholderServicesSmall from '../images/placeholders/servicesSmall.jpg';

import placeholderBioBank from '../images/placeholders/services.jpg';
import placeholderBioBankSmall from '../images/placeholders/servicesSmall.jpg';

import placeholderConsentAndAgreement from '../images/placeholders/services.jpg';
import placeholderConsentAndAgreementSmall from '../images/placeholders/servicesSmall.jpg';

import Loader from './Loader';

const PlaceHolderIds = {
  /* special case: loader for when stuff is loading */
  LOADER: 'loader',

  /* keys for individual pages */
  TIMELINE: 'timeline',
  QUESTIONNAIRES: 'questionnaires',
  REMOTECLINIC: 'remoteclinic',
  CARECONVERSATIONS: 'careconversations',
  APPOINTMENTS: 'appointments',
  SERVICES: 'services',
  CONSENTANDAGREEMENT: 'consentandagreement',
  BIOBANK: 'biobank',
};

let imageList = {
  [PlaceHolderIds.TIMELINE]: placeholderTimeline,
  [PlaceHolderIds.QUESTIONNAIRES]: placeholderQuestionnaires,
  [PlaceHolderIds.REMOTECLINIC]: placeholderRemoteClinic,
  [PlaceHolderIds.CARECONVERSATIONS]: placeholderCareConversations,
  [PlaceHolderIds.APPOINTMENTS]: placeholderAppointments,
  [PlaceHolderIds.SERVICES]: placeholderServices,
  [PlaceHolderIds.CONSENTANDAGREEMENT]: placeholderConsentAndAgreement,
  [PlaceHolderIds.BIOBANK]: placeholderBioBank,

  [PlaceHolderIds.TIMELINE + 'Small']: placeholderTimelineSmall,
  [PlaceHolderIds.QUESTIONNAIRES + 'Small']: placeholderQuestionnairesSmall,
  [PlaceHolderIds.REMOTECLINIC + 'Small']: placeholderRemoteClinicSmall,
  [PlaceHolderIds.CARECONVERSATIONS + 'Small']:
    placeholderCareConversationsSmall,
  [PlaceHolderIds.APPOINTMENTS + 'Small']: placeholderAppointmentsSmall,
  [PlaceHolderIds.SERVICES + 'Small']: placeholderServicesSmall,
  [PlaceHolderIds.CONSENTANDAGREEMENT + 'Small']:
    placeholderConsentAndAgreementSmall,

  [PlaceHolderIds.BIOBANK + 'Small']: placeholderBioBankSmall,
};

const imageCache = {};

/**
 * Shows image, and since ad images are quite big,
 * pre-load a small thumbnail initially. When the full image has
 * loaded, show it instead.
 *
 * See _ad_image.scss for styles
 * */
class ImageWithPlaceholder extends React.Component {
  render() {
    let { id, image, placeholder } = this.props;

    let imageSrc = null,
      cacheHit = false;

    if (imageCache[id]) {
      // if image is already loaded, just get the source attribute
      imageSrc = imageCache[id];
      cacheHit = true;
    } else {
      // if image is not loaded, then start loading it
      imageSrc = new Image();
      imageSrc.src = image;
      imageSrc.onload = () => {
        // when image has loaded, show the actual image and hide placeholder
        // (the initial display of the full image is "none" so it's hidden)
        if (this.image) this.image.style.display = 'block';
        if (this.placeholder) this.placeholder.style.opacity = '0';
      };
      imageCache[id] = imageSrc;
    }

    return (
      <div className={'ad-image'}>
        {/* The full image */}
        <div
          className={'ad-image__image'}
          style={{
            backgroundImage: `url(${imageSrc.src})`,
            display: cacheHit ? 'block' : 'none',
          }}
          ref={(elem) => (this.image = elem)}
        />
        {/* The blurred, tiny thumbnail placeholder */}
        <div
          className={'ad-image__placeholder'}
          style={{
            backgroundImage: `url(${placeholder})`,
            display: cacheHit ? 'none' : 'block',
          }}
          ref={(elem) => (this.placeholder = elem)}
        />
      </div>
    );
  }
}

/**
 *
 * @param id
 * @returns {*}
 * @constructor
 */
const PagePlaceholder = ({ id, children }) => {
  // Special case: if id is "loader", show loader
  if (id === 'loader') return <Loader />;

  return (
    <Span>
      {/* Heading */}
      <h1>
        <FormattedMessage id={`placeholder.${id}.title`} />
      </h1>
      {/* Text */}
      <div style={{ marginBottom: '40px' }}>
        <FormattedMessage
          id={`placeholder.${id}.text`}
          values={{
            p: (chunks) => <p className="ot-placeholder-paragraph">{chunks}</p>,
            valLink: (chunks) => (
              <a
                href="http://valinnanvapaus.fi"
                target="_blank"
                rel="noreferrer"
              >
                {chunks}
              </a>
            ),
          }}
        />
      </div>
      {children}
      {/* Image */}
      <ImageWithPlaceholder
        id={id}
        image={imageList[id]}
        placeholder={imageList[id + 'Small']}
      />
    </Span>
  );
};

export { PlaceHolderIds, PagePlaceholder };
